import { useMemo } from 'react';
import type { AdminWhatsappTemplateRow } from '../../../domain/superadmin/types';
import { buildSampleVars } from '../../../domain/superadmin/emailTest';
import { interpolateTemplate } from '../../../domain/superadmin/communications';
import { Button } from '../../../components/ui';
import Modal from '../../../components/ui/Modal';
import { WhatsappChatBubble } from './WhatsappChatBubble';

interface WhatsappTemplatePreviewModalProps {
    template: AdminWhatsappTemplateRow | null;
    isOpen: boolean;
    onClose: () => void;
    onSendTest: (template: AdminWhatsappTemplateRow) => void;
}

export function WhatsappTemplatePreviewModal({
    template,
    isOpen,
    onClose,
    onSendTest,
}: WhatsappTemplatePreviewModalProps) {
    // Production app URL — matches Edge APP_URL / real customer messages (not localhost).
    const sampleVars = useMemo(() => buildSampleVars(), []);

    const body = useMemo(
        () => (template ? interpolateTemplate(template.bodyText, sampleVars) : ''),
        [template, sampleVars],
    );

    if (!template) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Header onClose={onClose}>{template.name}</Modal.Header>
            <Modal.Body>
                <WhatsappChatBubble text={body} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Fechar
                </Button>
                <Button onClick={() => onSendTest(template)}>Enviar teste</Button>
            </Modal.Footer>
        </Modal>
    );
}
